import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import PropTypes from "prop-types"; // For type-checking props
import styles from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const Dropdown = forwardRef(
  ({ options, placeholder, onSelect, value }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(options);

    const handleToggle = () => {
      setIsOpen((prev) => !prev);
      setSearchTerm("");
      setFilteredOptions(options);
    };

    const handleOptionClick = (option) => {
      setSelectedOption(option.name);
      onSelect(option);
      setIsOpen(false);
    };

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleSearch = (event) => {
      const value = event.target.value;
      setSearchTerm(value);

      const filtered = options.filter((option) =>
        option.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    };

    // Expose a clearSelection method to the parent
    useImperativeHandle(ref, () => ({
      clearSelection: () => setSelectedOption(""),
    }));

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    return (
      <div className={styles.dropdown} ref={dropdownRef}>
        <button
          type="button"
          onClick={handleToggle}
          className={
            selectedOption === "" && value === undefined
              ? styles.dropdownButton
              : styles.dropdownSeletedButton
          }
        >
          {selectedOption.length > 500
            ? `${selectedOption.substring(0, 70)} ...`
            : selectedOption || placeholder || "Select an Option"}
          <FontAwesomeIcon icon={faAngleDown} />
        </button>
        {isOpen && (
          <div className={styles.dropdownMenuContainer}>
            <ul className={styles.dropdownMenu}>
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Search"
                className={styles.searchInput}
              />
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <li key={option.id} onClick={() => handleOptionClick(option)}>
                    {option.name}
                  </li>
                ))
              ) : (
                <li className={styles.noOptions}>No Options Found</li>
              )}
            </ul>
          </div>
        )}
      </div>
    );
  }
);

Dropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

export default Dropdown;
